import StudioProjectAPI from 'dashboard/api/studio/project';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioProject',
  API: StudioProjectAPI,
  actions: mutationTypes => {
    const versionAction =
      apiCall =>
      async ({ commit }, { projectId, versionId, ...options }) => {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        try {
          const response = await apiCall(projectId, versionId, options);
          return response.data;
        } finally {
          commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
        }
      };

    return {
      restore: async ({ commit }, id) => {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        try {
          const response = await StudioProjectAPI.restore(id);
          commit(mutationTypes.EDIT, response.data);
          return response.data;
        } finally {
          commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
        }
      },
      fetchDetail: async ({ commit }, projectId) => {
        commit(mutationTypes.SET_UI_FLAG, { fetchingItem: true });
        try {
          const response = await StudioProjectAPI.show(projectId);
          return response.data;
        } finally {
          commit(mutationTypes.SET_UI_FLAG, { fetchingItem: false });
        }
      },
      copyVersion: versionAction(
        StudioProjectAPI.copyVersion.bind(StudioProjectAPI)
      ),
      discardVersion: versionAction(
        StudioProjectAPI.discardVersion.bind(StudioProjectAPI)
      ),
      startHomologation: versionAction(
        StudioProjectAPI.startHomologation.bind(StudioProjectAPI)
      ),
      approveVersion: versionAction(
        StudioProjectAPI.approveVersion.bind(StudioProjectAPI)
      ),
      rejectVersion: versionAction(
        StudioProjectAPI.rejectVersion.bind(StudioProjectAPI)
      ),
      activateVersion: versionAction(
        StudioProjectAPI.activateVersion.bind(StudioProjectAPI)
      ),
      // Edita só a nota da versão (release_notes). options = { release_notes }.
      updateVersion: versionAction(
        StudioProjectAPI.updateVersion.bind(StudioProjectAPI)
      ),
    };
  },
});
